/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';
import { BsPlusCircle, BsDashCircle } from 'react-icons/bs';
import { FieldArray, useFormikContext } from 'formik';

import { DetailRequest } from '../../utils/globalPropTypes';
import './ProvidersForm.scss';
import ContractAlert from '../ContractAlert/ContractAlert';

import useProviderForm from './useProviderForm';
import SelectProviderForm from './SelectProviderForm';
import HeaderProviderForm from './HeaderProviderForm';

const ProviderRequestDetailsContainer = (props) => {
  const { details, setNewProviderData, providerValue } = props;

  const [notificationArray, setNotificationArray] = useState([]);

  const { values, setFieldValue, setFieldTouched, errors, touched } = useFormikContext();

  const {
    businessUnit,
    contractArray,
    businessUnitSwitch,
    fetchProviders,
    fetchContract,
    removeContractsFromProvider,
    fetchNotification,
    switchBusinessUnit,
    fetchAlerts
  } = useProviderForm({
    providerValue: providerValue?.providers,
    providerField: `providers`,
    setNotificationArray,
    replyRequest: false,
    editRequest: false,
    requestValue: null,
    requestDetails: true
  });

  useEffect(() => {
    if (values.providers.length) {
      setNewProviderData(values.providers);
    }
  }, [values]);

  const switchInputChange = () => {
    switchBusinessUnit();
    if (values.providers.length) {
      values.providers.forEach((_, index) => {
        setFieldValue(`providers[${index}].businessUnit`, details.unidadNegocio);
      });
    }

    values.providers.forEach((current, index) => {
      if (businessUnitSwitch && current.businessUnit.id !== details.unidadNegocio.id) {
        setFieldValue(`providers[${index}].provider`, null);
        setFieldValue(`providers[${index}].contract`, null);
        setFieldValue(`providers[${index}].notificate`, null);
      }
    });

    const filteredProviders = values?.providers?.filter(
      (p) => p.businessUnit.id === details.unidadNegocio.id
    );

    if (filteredProviders.length) {
      setFieldValue('providers', filteredProviders);
    } else {
      setFieldValue('providers', [
        {
          contract: null,
          notificate: null,
          provider: null,
          businessUnit: {
            id: details.unidadNegocio.id,
            value: details.unidadNegocio.id,
            nombre: details.unidadNegocio.nombre,
            label: details.unidadNegocio.nombre
          }
        }
      ]);
    }
  };

  const handleOnChangeContract = async (val, index) => {
    if (val?.id !== values?.providers[index]?.contract?.id) {
      setFieldValue(`providers[${index}].contract`, val);
      if (values?.providers[index]?.notificate) {
        setFieldTouched(`providers[${index}].notificate`);
      }
      setFieldValue(`providers[${index}].notificate`, null);
    }
    if (val) {
      fetchAlerts(val.nombre, index);
      fetchNotification(values?.providers[index]?.businessUnit.id, val.nombre, index);
    } else {
      setFieldValue(`providers[${index}].notificate`, null);
    }
  };

  const handleOnChangeProvider = async (val, index) => {
    if (val?.id !== values?.providers[index]?.provider?.id) {
      setFieldValue(`providers[${index}].provider`, val);
      if (val?.id !== values?.providers[index]?.provider?.id && !businessUnitSwitch) {
        setFieldTouched(`providers[${index}].provider`);
      }
    }
    if (val) {
      fetchContract(
        values?.providers[index]?.businessUnit.id,
        details.servicio.id,
        val.id,
        index,
        null,
        details?.idEvento
      );
    } else {
      removeContractsFromProvider(index);
      setFieldValue(`providers[${index}].contract`, null);
      setFieldValue(`providers[${index}].notificate`, null);
    }
  };

  const handleOnChangeUunn = async (val, index) => {
    if (val?.id !== values?.providers[index]?.businessUnit?.id) {
      setFieldValue(`providers[${index}].businessUnit`, val);
    }
    setFieldValue(`providers[${index}].provider`, null);
    setFieldValue(`providers[${index}].contract`, null);
    setFieldValue(`providers[${index}].notificate`, null);
  };

  return (
    <FieldArray name="providers">
      {({ remove, push }) => (
        <div>
          <HeaderProviderForm
            businessUnitSwitch={businessUnitSwitch}
            buttonAddProvider={{
              disabled: values?.providers?.some((provider) => provider?.notificate === null),
              icon: BsPlusCircle,
              onClick: () => {
                push({
                  provider: '',
                  contract: null,
                  notificate: null,
                  businessUnit: {
                    id: details.unidadNegocio.id,
                    value: details.unidadNegocio.id,
                    nombre: details.unidadNegocio.nombre,
                    label: details.unidadNegocio.nombre
                  }
                });
              }
            }}
            createSDS
            label={<h6>Solicitar a</h6>}
            onChangeSwitch={() => switchInputChange()}
          />

          <hr />
          {providerValue?.providers?.map((providerForm, index) => (
            <Row className="mt-3" key={`${providerForm?.provider?.id}-provider`}>
              <SelectProviderForm
                businessUnitSwitch={businessUnitSwitch}
                buttonRemove={{
                  disabled: providerValue?.providers?.length <= 1,
                  onClick: () => {
                    remove(index);
                    removeContractsFromProvider(index);
                  },
                  icon: BsDashCircle
                }}
                detailSDS
                selectContract={{
                  customLabel: providerForm?.alert?.alert && (
                    <ContractAlert message={providerForm?.alert?.message} />
                  ),
                  isDisabled: !values?.providers[index]?.provider,
                  isInvalid:
                    errors?.providers && touched?.providers
                      ? !!touched?.providers[index]?.contract &&
                        !!errors?.providers[index]?.contract
                      : false,
                  name: `providers[${index}].contract`,
                  onChange: async (val) => handleOnChangeContract(val, index),
                  options: contractArray?.filter((__, indexContract) => indexContract === index)[0]
                    ?.contracts,
                  value: values?.providers[index]?.contract,
                  availableAmount: providerForm?.alert?.availableAmount
                }}
                selectNotificate={{
                  isDisabled:
                    !values?.providers[index]?.provider || !values?.providers[index]?.contract,
                  isInvalid:
                    errors?.providers && touched?.providers
                      ? !!touched?.providers[index]?.notificate &&
                        !!errors?.providers[index]?.notificate
                      : false,
                  name: `providers[${index}].notificate`,
                  onChange: async (val) => {
                    setFieldValue(`providers[${index}].notificate`, val);
                  },
                  options: notificationArray,
                  value: values.providers[index]?.notificate
                }}
                selectProvider={{
                  fetchData: (value) =>
                    fetchProviders(
                      value,
                      values?.providers[index]?.businessUnit?.id,
                      details.servicio?.id
                    ),
                  isDisabled: !values?.providers[index]?.businessUnit,
                  isInvalid: !values?.providers[index]?.businessUnit,
                  name: `providers[${index}].provider`,
                  onChange: async (val) => handleOnChangeProvider(val, index),
                  value: values?.providers[index]?.provider
                }}
                selectUunn={{
                  errors: undefined,
                  isDisabled: !businessUnitSwitch,
                  isInvalid:
                    errors?.providers && touched?.providers
                      ? !!touched?.providers[index]?.businessUnit &&
                        !!errors?.providers[index]?.businessUnit
                      : false,
                  name: `providers[${index}].businessUnit`,
                  onChange: async (val) => handleOnChangeUunn(val, index),
                  options: businessUnit,
                  value: values?.providers[index]?.businessUnit
                }}
              />
            </Row>
          ))}
        </div>
      )}
    </FieldArray>
  );
};

ProviderRequestDetailsContainer.propTypes = {
  details: DetailRequest.isRequired,
  setNewProviderData: PropTypes.func,
  providerValue: PropTypes.shape({
    providers: PropTypes.arrayOf(
      PropTypes.shape({
        businessUnit: PropTypes.objectOf(
          PropTypes.shape({
            id: PropTypes.number,
            label: PropTypes.string,
            nombre: PropTypes.string,
            value: PropTypes.number
          })
        ),
        provider: PropTypes.objectOf(
          PropTypes.shape({
            id: PropTypes.number,
            label: PropTypes.string,
            nombre: PropTypes.string,
            value: PropTypes.number
          })
        ),
        notificate: PropTypes.objectOf(
          PropTypes.shape({
            id: PropTypes.number,
            label: PropTypes.string,
            nombre: PropTypes.string,
            value: PropTypes.number
          })
        ),
        contract: PropTypes.objectOf(
          PropTypes.shape({
            id: PropTypes.number,
            inspectoresIds: PropTypes.arrayOf({}),
            label: PropTypes.string,
            requiereAceptacion: PropTypes.bool,
            requiereSolicitud: PropTypes.bool,
            requiereAdjuntarArchivo: PropTypes.bool,
            nombre: PropTypes.string,
            moneda: PropTypes.string,
            value: PropTypes.number
          })
        )
      })
    )
  }).isRequired
};

ProviderRequestDetailsContainer.defaultProps = {
  setNewProviderData: () => {}
};
export default ProviderRequestDetailsContainer;
